import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { PDFViewer } from '@react-pdf/renderer';
import MissionOrderPDF from './MissionOrderPDF';

const PDFModalMission = ({ missionData, onClose }) => {
  return (
    <Dialog open={true} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Voir PDF - Ordre de Mission</DialogTitle>
      <DialogContent>
        <PDFViewer style={{ width: '100%', height: '600px' }}>
          <MissionOrderPDF
            data={missionData}
          />
        </PDFViewer>
      </DialogContent>
    </Dialog>
  );
};

export default PDFModalMission;
